const state = {
  data: {
    result: -1,
    success: [],
    fail: []
  },
  indexByNo: {},
  needReload: false,
  user: null,
  // 0 - 로그인 안됨, 1 - 일반사용자, 2 - 관리자
  isAuth: 0,
  // 세션 종료 시간
  sessionTimeout: 0,
  param: {
    filter: {},
    sort: [{ field: 'userNo', order: 'DESC' }]
  },
  totalPages: 0,
  totalCount: 0,
  inputValues: {}
}

const actions = {
  CHANGE_FILTER: ({ commit }, payload) => {
    commit('MUTATION_CHANGE_FILTER', payload);
  },
  GET_USER: ({ commit }, params) => {
    commit('MUTATION_GET_USER', params);
  },
  ADD_USER: ({ commit }, params) => {
    commit('MUTATION_ADD_USER', params);
  },
  UPDATE_USER: ({ commit }, params) => {
    commit('MUTATION_UPDATE_USER', params);
  },
  SET_USER: ({ commit }, params) => {
    commit('MUTATION_SET_USER', params);
  },
  DELETE_USER: ({ commit }, params) => {
    commit('MUTATION_DELETE_USER', params);
  },
  LOGOUT: ({ commit }, params) => {
    commit('MUTATION_LOGOUT', params);
  },
  INIT_INPUT_VALUE: ({ commit }, params) => {
    commit('MUTATION_INIT_INPUT_VALUE', params);
  },
  SET_INPUT_VALUE: ({ commit }, params) => {
    commit('MUTATION_SET_INPUT_VALUE', params);
  }
}

const mutations = {
  MUTATION_CHANGE_FILTER: (state, payload) => {
    state["param"]["filter"] = payload;
  },
  MUTATION_GET_USER: (state, payload) => {
    if (payload && payload.data && payload.data.list) {
      const { list } = payload.data;
      const { offset, limit } = payload.config.params;
      const totalCount = list && list.length > 0 ? list[0].rnum + offset : 0;
      const totalPages = Math.ceil(totalCount / limit);
      state['user'] = list ? list[0] : null;
      state['needReload'] = false;
      state['totalCount'] = totalCount;
      state['totalPages'] = totalPages;
      state['selectedNoArray'] = [];
    }
  },
  MUTATION_ADD_USER: (state, payload) => {
    state['needReload'] = true;
  },
  MUTATION_UPDATE_USER: (state, payload) => {
    if (payload && payload.data && payload.data.list) {
      state['user'] = payload.data.list[0];
      state['needReload'] = true;
    }
  },
  MUTATION_DELETE_USER: (state, payload) => {
    state['needReload'] = true;
  },
  MUTATION_SET_USER: (state, payload) => {
    state['user'] = payload.user;
    state['isAuth'] = payload.user.isAdmin === 1 ? 2 : 1;
    state['sessionTimeout'] = payload.sessionTimeout;
  },
  MUTATION_LOGOUT: (state, payload) => {
    state['user'] = null;
    state['isAuth'] = 0;
  },
  MUTATION_INIT_INPUT_VALUE: (state, payload) => {
    state['inputValues'] = {};
  },
  MUTATION_SET_INPUT_VALUE: (state, payload) => {
    Object.keys(payload).map(key => {
      state["inputValues"][key] = payload[key];
    })
  },
}

const getters = {
  STATE: (state) => {
    return state;
  },
  DATA: (state) => {
    return state.data;
  },
  GET_INPUT_VALUES: (state) => {
    return state.inputValues;
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}